export const emailTypes = ['work', 'home'] as const;

export const phoneTypes = [...emailTypes, 'mobile'] as const;
